import { ImageKinds } from "../ImageKinds";
import { IDocumentImageSource } from "./../IDocumentImageSource";
import { IItem, instanceOfIItem } from "./IItem";

export interface IClaioSchemaExecutable extends IItem {
  imageSource: IDocumentImageSource;
  imageKind: ImageKinds;
}

export function instanceOfIClaioSchemaExecutable(instance: any): instance is IClaioSchemaExecutable {
  if (!instance) { return false; }
  return (instance.imageSource !== undefined)
    && (instance.imageKind !== undefined)
    && instanceOfIItem(instance);
}
